export const styles = {
	loadingElementContainer: {
		marginTop: '1em',
	},
	solutionText: {
		color: '#000000DE',
		fontStyle: 'italic',
		fontSize: '16px',
		margin: '10px 0 10px 0',
	},
	aiButton: {
		'&&': {
			height: '48px',
		},
	},
	typography: {
		color: 'black',
		opacity: 0.87,
		fontSize: '12px',
	},
	listItem: {
		margin: '10px 0 10px 0',
	},
}
